module.exports = __webpack_public_path__ + "static/media/BTN.9bf1eb7c.svg";